import { getPolicyStatus } from "./policyService";

export const fetchPolicyStatus =
  (applicationNumber) => async () => {

    const response = await getPolicyStatus(applicationNumber);

    return response;
};